import React, { useState } from "react";

import UserAccountCreateFormComp from "./UserAccountCreateFormComp";
import UserAccountPreviewComp from "./UserAccountPreviewComp"
import ErrorComp from "../common/ErrorComp";
import { fetchCall } from "../../common/FetchHelpers";

import DateUtil from "../../common/dateUtil";


const UserAccountCreateComp = (props) => {

    const createAccountUrl = "api/user-account/create";

    const emptyUserAccount = {
        accountNumber: "",
        accountName: "",
        brokerDealerName: "",
        beneficiaries:[''],
        accountRelation:"",
        otherRelation:"",
        accountRegistration:"",
        otherRegistration:"",
        accountType:"",
        accountOpenDate:"",
        professionallyManaged:"N"
    };


    const [showEditor, setShowEditor] = useState(true);
    const [showPreview, setShowPreview] = useState(false);
    const [showError, setShowError] = useState(false);
    const [detailMode, setDetailMode] = useState("PREVIEW");
    const [formData, updateFormData] = useState(emptyUserAccount);


    const validateForm = () => {
        //console.log("Validate the form");
        return true;
    };

    const handleChange = (e) => {
        if (e.target.name === "brokerDealerId") {
            let rrName = "";
            let rr = props.metadata.brokerDealer.find((obj) => {
                return obj.id === e.target.value;
            });
            if (rr) {
                rrName = rr.name;
            }
            updateFormData({ ...formData, [e.target.name]: e.target.value, brokerDealerName: rrName});
        } else if(e.target.name === 'submittedFor') {
            updateFormData({ ...formData, [e.target.name]: e.target.value, submittedForLabel: e.target.label});
        } else {
            const value = (e.target.files && e.target.files[0])?e.target.files[0]:e.target.value;
            updateFormData({...formData, [e.target.name]: value});
        }

        console.log(formData);
        console.log(e.target.name);
    };

    
  const handleDateChange = (date) => {
    updateFormData({
      ...formData,
      accountOpenDate: date
    });
  };




  const beneficiaryChange = (e,idx)=>{

    const temp = [...formData.beneficiaries];
    temp[idx] = e.target.value;
    updateFormData({
        ...formData,
        beneficiaries: temp
    });

  };

    const beneficiaryAdd =()=>{
        const beneficiaries = [...formData.beneficiaries,''];
        updateFormData({
            ...formData,
            beneficiaries: beneficiaries
        });
    };

    const beneficiaryRemove =(idx)=>{
        if(formData.beneficiaries.length>1){
            const temp = [...formData.beneficiaries];
            temp.splice(idx, 1);
            updateFormData({
                ...formData,
                beneficiaries: temp
            });
        }else{
            updateFormData({
                ...formData,
                beneficiaries: ['']
            });
        }
    };



    const handleSaveClick = () => {
        if (validateForm()) {
            setShowEditor(false);
            setShowPreview(true);
        }
    };


    const handleSubmit = () => {
        if (detailMode === "PREVIEW") {
            setDetailMode("POSTREVIEW");

            console.log(formData);

            const jsonData = { ...formData,
                brokerDealerId:formData.brokerDealerId === 'Other'?null:formData.brokerDealerId
                ,accountOpenDate:DateUtil.toStrDate(formData.accountOpenDate)
                ,accountRelation:formData.accountRelation==='Other'?formData.otherRelation:formData.accountRelation
                ,accountRegistration:formData.accountRegistration==='Other'?formData.otherRegistration:formData.accountRegistration
                ,beneficiaries: formData.beneficiaries.join('|')
                };

                console.log(jsonData);

                const fData = new FormData();

            fData.append("accountName",jsonData.accountName);
            fData.append("accountNumber",jsonData.accountNumber);
            fData.append("accountOpenDate",jsonData.accountOpenDate);
            fData.append("accountRegistration",jsonData.accountRegistration);
            fData.append("accountRelation",jsonData.accountRelation);
            fData.append("accountType",jsonData.accountType);
            fData.append("file",jsonData.attachment);
            fData.append("beneficiaries",jsonData.beneficiaries);
            fData.append("brokerDealerName",jsonData.brokerDealerName);
            fData.append("professionallyManaged",jsonData.professionallyManaged);
            
            if(formData.brokerDealerId !== 'Other') fData.append("brokerDealerId",jsonData.brokerDealerId);

            if(jsonData.otherBrokerDealer) fData.append("otherBrokerDealer",jsonData.otherBrokerDealer);
            if(jsonData.otherBrokerDealerAddress) fData.append("otherBrokerDealerAddress",jsonData.otherBrokerDealerAddress);
            if(jsonData.otherBrokerDealerContact) fData.append("otherBrokerDealerContact",jsonData.otherBrokerDealerContact);

            if(jsonData.submittedFor) fData.append("submittedFor",jsonData.submittedFor);

            //fData.append("otherRegistration",jsonData.id);
            //fData.append("otherRelation",jsonData.id);


            const reqOptions = {
                method: "POST",
                body: fData,
            };

            fetchCall(createAccountUrl, reqOptions)
                .then((result)=>{
                    setDetailConfig({
                        ...detailConfig,
                        title: "Account Created",
                        status: {
                            state: "success",
                            message: "Account successfully created",
                        },
                        btnOk: {
                            ...detailConfig.btnOk,
                            label: "Add Another Account",
                        },
                        btnCancel: {
                            label: "Close",
                            handler: props.handleClose,
                        },
                    });

                })
                .catch((err)=>{
                    console.log("Error, with message:", err.statusText);
                    setShowEditor(false);
                    setShowPreview(false);
                    setShowError(true);
        
                }
            );
        } else {
            console.log("Add Another Clicked");
            handleAddAnother();
        }
    };

    const handleClosePreview = () => {
        console.log("Testing context");

        console.log(formData);
        setShowEditor(true);
        setShowPreview(false);
    };

    const handleAddAnother = () => {
        console.log("adding another one clicked");
        //reset to preview mode for the page
        setDetailMode("PREVIEW");
        setDetailConfig(defaultConfig);
        updateFormData(emptyUserAccount);
        handleClosePreview();
    };



    const defaultConfig = {
        title: "Review your account before save",
        status: {
            state: "",
            message: "",
        },
        btnOk: {
            label: "Submit",
            handler: handleSubmit,
        },
        btnCancel: {
            label: "Edit",
            handler: handleClosePreview,
        },
    };
    const [detailConfig, setDetailConfig] = useState(defaultConfig);


    return (

        <>
            {showPreview && (
                <UserAccountPreviewComp
                    config={detailConfig}
                    data={formData}
                    btnOk={{
                        label: detailConfig.btnOk.label,
                        handler: handleSubmit,
                    }}
                />
            )}

            {showEditor &&
                <UserAccountCreateFormComp
                    data={formData}
                    metadata={props.metadata}
                    handleChange={handleChange}
                    handleDateChange={handleDateChange}
                    beneficiaryChange={beneficiaryChange}
                    beneficiaryAdd={beneficiaryAdd}
                    beneficiaryRemove={beneficiaryRemove}
                    handleSaveClick={handleSaveClick}
                    handleCancel={props.handleClose} />
            }
            {showError && <ErrorComp />}

        </>
    );
}

export default UserAccountCreateComp;